import React, { useMemo } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DialogContent } from 'Views/Page/Content/Modal/Components';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import ChiliPiperComponent from 'Components/ComponentLibrary/Molecules/ChiliPiperComponent/ChiliPiperComponent';
import { TalkToSupport } from 'Views/Page/Content/Modal/Layouts/requestChurnWithConcessionsSelectionStep/talkToSupport';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useChiliPiperContext } from 'Components/ComponentLibrary/Molecules/ChiliPiperComponent/ChiliPiperContext';
import { Offers } from './offers';
import { Cancel } from './cancel';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const offerOptions = useMemo(() => resource.attr('offers').resources().list(), [resource]);
  const { displayErrorMessage } = useSnackbarContext();
  const { loadModalCollectionByLink, setModalCollection } = useModalContext();

  const talkToSupportResource = resource.attr('talkToSupport').resources().head();
  const cancelRel = resource?.relationship(fr.relationships.cancelAnyways.name);

  const doRedirect = async () => {
    try {
      await loadModalCollectionByLink(talkToSupportResource.relationship(fr.relationships.redirectOnClose.name).link('related').url());
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Failed to redirect to complete step');
      }
    }
  };

  const {
    setOpenIFrame, showChiliPiperComponent, chiliPiperRel, handleChiliPiperExit,
  } = useChiliPiperContext(talkToSupportResource, doRedirect);

  const onTalkToSupportClick = () => {
    setOpenIFrame(true);
  };

  return (
    (showChiliPiperComponent ? (
      <ChiliPiperComponent rel={chiliPiperRel} handleChiliPiperExit={handleChiliPiperExit} />
    )
      : <>
        <MetaControlField attr="title" />
        <DialogContent scrollKey={resource?.type() + resource?.id()}>
          <FDStack direction="column" spacing={2}>
            <MetaControlField attr="description" />
            <Offers
              options={offerOptions}
              onChoose={async (item) => {
                const nextModalCollection = await item.link('self').post();
                setModalCollection(nextModalCollection);
              }}
            />
            {talkToSupportResource && chiliPiperRel
              ? <TalkToSupport relationship={chiliPiperRel} onClick={onTalkToSupportClick} description={talkToSupportResource.attr('description')} />
              : null
            }
            <MetaControlField attr="disclaimer" />
            {cancelRel ? <Cancel relationship={cancelRel} /> : null }
            <FDStack justifyContent="center">
              <MetaControlField attr="cancelId" />
            </FDStack>
          </FDStack>
        </DialogContent>
      </>
    ));
};

export default Layout;
